<template>
  <yoyaku v-if="yoyaku" />
  <signage v-else-if="signage" />
  <dashboard v-else />
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import Store from '@/store';
import Dashboard from '@/app/Dashboard.vue';
import Yoyaku from '@/app/Yoyaku.vue';
import Signage from '@/app/Signage.vue';

@Component({
  components: {
    Dashboard,
    Yoyaku,
    Signage,
  },
})
export default class App extends Vue {
  get yoyaku(): boolean {
    return Store.getters.app === 'yoyaku';
  }

  get signage(): boolean {
    return Store.getters.app === 'signage';
  }
}
</script>

<style lang="scss">
::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
.v-app-bar--is-scrolled div {
  top: 0px !important;
}
</style>
